import type { HandoverBizData } from "@/api/user/types/handover"

type HandoverPrintEmployees = Pick<HandoverBizData, "overUserName" | "handoverUserName"> & {
  openUserName?: string
  startUserName?: string
}

export function getHandoverPrintEmployees(data?: HandoverPrintEmployees) {
  return {
    opener: data?.openUserName?.trim() || data?.startUserName?.trim() || data?.overUserName?.trim() || "未记录",
    // 开班人不能作为实际交班人缺失时的替代值。
    operator: data?.handoverUserName?.trim() || "未记录",
  }
}
